import {TorchlightCollectionItem} from '@/domains/shared/components/TorchlightCollectionItem';
import {Tab}                      from '@headlessui/react';
import classNames                 from 'classnames';
import {
	Children,
	Fragment,
	useRef,
	useState,
}                                 from 'react';

export function TorchlightCollection({
	                                     type,
	                                     children,
                                     }) {
	let columnDefinition = '1fr 5px 1fr';

	const [isDragging, setIsDragging] = useState(false);
	const rootElement                 = useRef(null);
	const leftElement                 = useRef(null);

	if (type === 'tabs') {
		return (<div className="shadow-lg md:rounded-xl not-prose relative">
			<Tab.Group as="div"
			           className="overflow-hidden md:rounded-xl bg-gray-900"
			>
				<div className="flex bg-gray-800/40 ring-1 ring-white/5">
					<Tab.List className="-mb-px flex text-sm font-medium leading-6 text-gray-400">
						{Children.map(children, (child, index) => {
							return (<Tab key={child.props.name}
							             as={Fragment}
							>
								{({selected}) => (<button
									className={classNames([
										'px-3 py-2 cursor-pointer select-none outline-0 border-r border-b',
										index < children.length - 1 ? 'border-r-white/10' : 'border-r-gray-600/10',
										selected ? 'bg-white/5 border-b-white/20 text-white' : 'border-b-gray-600/50 text-white/75',
									])}
								>
									{child.props.name}
								</button>)}
							</Tab>);
						})}
					</Tab.List>
				</div>
				<Tab.Panels>
					{Children.map(children, (child, index) => {
						return (<Tab.Panel key={child.props.name}>
							{child}
						</Tab.Panel>);
					})}
				</Tab.Panels>
			</Tab.Group>
		</div>);
	} else if (type === 'side-by-side') {
		// This code was adapted from https://codepen.io/lukerazor/pen/GVBMZK

		function setCursor(cursor) {
			rootElement.current.style.cursor = cursor;
		}

		function startDrag() {
			setIsDragging(true);
			setCursor('ew-resize');
		}

		function endDrag() {
			setIsDragging(false);
			setCursor('auto');
		}

		function onDrag(event) {
			if (isDragging) {
				let page = rootElement.current;

				let leftColWidth = Math.min(page.clientWidth * 0.8, Math.max(page.clientWidth * 0.2, event.clientX - page.getBoundingClientRect().x));

				let handleWidth = 5;

				let cols = [
					leftColWidth,
					handleWidth,
					page.clientWidth - handleWidth - leftColWidth,
				];

				columnDefinition = cols
					.map(c => c.toString() + 'px')
					.join(' ');

				page.style.gridTemplateColumns = columnDefinition;

				event.preventDefault();
			}
		}

		return (<div className="shadow-lg md:rounded-xl not-prose overflow-hidden">
			<div className="md:rounded-xl bg-gray-900 divide-y-2 divide-teal-500 md:grid md:divide-y-0"
			     ref={rootElement}
			     onMouseUp={() => endDrag()}
			     onMouseMove={onDrag}
			     style={{
				     gridTemplateAreas:   '\'left handle right\'',
				     gridTemplateColumns: columnDefinition,
			     }}
			>
				<TorchlightCollectionItem child={children[0]}
				                          style={{gridArea: 'left'}}
				                          className="overflow-auto"
				                          innerRef={leftElement}
				/>

				<div className="hidden md:block bg-teal-500 min-w-fit w-full cursor-ew-resize"
				     style={{gridArea: 'handle'}}
				     onMouseDown={() => startDrag()}
				></div>

				<TorchlightCollectionItem child={children[1]}
				                          style={{gridArea: 'right'}}
				                          className="overflow-auto"
				/>
			</div>
		</div>);
	}

	return null;
}